(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/helpers/handlebar-helpers.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/helpers/handlebar-helpers.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

(function () {
  'use strict';

  function registerHelpers(hbs) {
    hbs.registerHelper('json', function (context) {
      var arr = JSON.stringify(context);
      return arr === undefined ? '[]' : arr;
    });
    hbs.registerHelper('hasText', function (text, options) {
      var fnTrue = options.fn;
      var fnFalse = options.inverse;
      return text && text !== '<p>&nbsp;</p>' ? fnTrue(this) : fnFalse(this);
    });
    hbs.registerHelper('addEllipsis', function (text) {
      return "".concat(text, "...");
    });
    hbs.registerHelper('boolean', function (text) {
      return Boolean(text);
    });
    hbs.registerHelper('showSummarized', function (text) {
      var aCloseTag = /<\/a>/g;
      var aOpenTag = /<a href="(.*?)">/g;
      if (text && text !== '<p>&nbsp;</p>') {
        return "".concat(text.replace(aOpenTag, '').replace(aCloseTag, '').slice(0, 363), "...");
      }
    });
  }
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }
})();

 })(window);